import styled from "styled-components";

const LogoStyle = styled.h1`
    color: #FF577F;

    font-size: 20px;
    
    white-space: nowrap;
    
    text-align: center;
`

export default LogoStyle;